<template>
  <div class="wrap  course-content">
     <h3 class="title">我的笔记</h3>
     <div class="note course-content" v-for="item in noteList" :key="item.id" @click="toDetail(item)">
       <div class="content">
        <img class="img" v-if="!item.is_video_delete" :src="item.cover_url" alt="">
        <img class="img" v-else src="../../images/note-lapse.png" alt="">
       </div>
       <div class="information">
        <div class="top">
          <p class="title1">{{item.name}}</p>
        </div>   
       <div class="bottom">
        <p class="time">笔记最新更新时间：{{item.update_at}}</p>
        <div class="button">
            <div class="delete" @click.stop="deleteNote(item)">删除笔记</div>
            <div v-if="!item.is_video_delete" class="video" @click.stop="goVideo(item)">前往视频</div>
       </div>
       </div>
       </div>
     </div>
      <div class="pagination">
        <el-pagination background :current-page.sync="page" @current-change="getList"  layout="prev, pager, next" :total="total"></el-pagination>
      </div>
  </div>
</template>

<script>
import { Message } from "element-ui";
export default {
   data(){
    return{
      page:1,
      total:0,
      noteList:[]
    }
   },
   created(){
     this.getList()
   },
   methods:{
    toDetail(item){
      console.log('[<-- item -->]',item);
       this.$emit('changePage',{page:'NoteDetail',query:item})
    },
    goVideo(item){
      this.$router.push({
        path:`/yueke3/${item.course_id}/${item.class_id}`,
      query:{
        view_time:item.view_time,video_id:item.video_id,chapter_id:item.chapter_id,sectionId:item.section_id,name:item.name,duration:item.duration,file_id:item.file_id
      }})
    },
    async deleteNote(item){
        let ids=[]
        ids.push(item.id)
        // ids=JSON.stringify(ids)
        const data={
          ids
        }
        const res=await this.$axios.post('/stu/course/deleteNote',data)
        if (res.data.code==200) {
          Message.success('删除成功')
          this.getList()
        }
        console.log('[<-- res -->]',res);
    },
    async getList(){
       const data={
        page:this.page,
        page_num:10
       }
       const res=await this.$axios.post('/stu/course/getNoteList',data)
       console.log('[<-- res--noteList -->]',res);
       this.noteList=res.data.data.list
       this.total=res.data.data.count
    }
   },
}
</script>

<style lang="scss" scoped>
.wrap {
  background: #ffffff;
  margin: 25px 0px 25px 25px;
  width: 100%;
  padding: 20px 30px;
  height: 880px;
  overflow-y: auto;
  scrollbar-width: none; 
  -ms-overflow-style: none;
  .title{
    font-size: 20px;
    color: #202020;
    padding-bottom: 17px;
    border-bottom: 1px solid #e8eaec;
    margin-bottom:0px
  }
  .note{
    height: 160px;
    box-sizing: border-box;
    background-color: #fff;
    border-bottom: 1px solid #e8eaec;
    padding:20px 0px;
    display: flex;
    justify-content: flex-start;
    .img{
      height:121px;
      width: 215px;
      margin-right: 12px;
      display: inline-block;
      border-radius: 4px;
    }
    .information{
        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: space-between;
        .top{
          display: flex;
        }
        p{
          padding: 0;
          margin: 0;
        }
        .bottom{
          display: flex;
          align-items: end;
          justify-content: space-between;
          .time{
          font-size: 14px;
          font-weight: 400;
          color: #999999;
          }
          .button{
            display: flex;
            align-items: center;
            .delete{
              width: 90px;
              height: 32px;
              border: 1px solid #1872ed;
              border-radius: 6px;
              color: #1872ed;
              line-height: 32px;
              text-align: center;
              cursor: pointer;
            }
            .video{
              width: 90px;
              height: 32px;
              background: linear-gradient(107deg,#73aaff 0%, #0053ff 100%);
              border-radius: 6px;
              color: #fff;
              line-height: 32px;
              margin-left: 20px;
              text-align: center;
              cursor: pointer;
            }
          }
        }
        .title1{
        font-size: 16px;
        font-weight: 400;
        color: #202020;
        }
      }
    }
  .pagination {
    display: flex;
    width: 100%;
    justify-content: center;
    margin-top: 20px;
  }
  .pagination >>> .el-pager li:not(.disabled).active {
    background: #1872ed;
  }
  .wrap ::-webkit-scrollbar {
    display: none;
  }
}
</style>